export default __webpack_public_path__ + "static/Hospitality-Photo2-61ed273bfa7501c7dcc60296bc2f19ea.png";